import { Link } from "wouter";

const PageResourceComponents = () => {
	return (
		<section className="max-w-4xl mx-auto text-left space-y-8 p-6 bg-slate-800/40 rounded-lg border border-slate-700">
			<header className="space-y-3 text-center">
				<h2 className="text-3xl md:text-4xl font-bold text-slate-100">About Metatech Components</h2>
				<p className="text-slate-400">A lightweight, framework-agnostic collection of accessible UI components built with Tailwind CSS. Ready to copy, customize and ship.</p>
			</header>

			<div className="grid md:grid-cols-2 gap-6">
				<div className="space-y-4">
					<h3 className="font-semibold text-slate-100">Quick Start</h3>
					<p className="text-slate-400 text-sm">Install the package or copy the component markup directly into your project. No runtime framework required.</p>
					<pre className="bg-slate-900 p-3 rounded text-xs overflow-auto text-emerald-300">
{`# NPM
npm install metatech-components

# Yarn
yarn add metatech-components`}
					</pre>
					<p className="text-slate-400 text-sm">Or copy the HTML and Tailwind classes from each component example.</p>
				</div>

				<div className="space-y-4">
					<h3 className="font-semibold text-slate-100">Usage</h3>
					<p className="text-slate-400 text-sm">Components are designed to be accessible and customizable via Tailwind utility classes.</p>
					<pre className="bg-slate-900 p-3 rounded text-xs overflow-auto text-amber-200">
{`<!-- Example button -->
<button class="px-4 py-2 rounded bg-amber-500 text-white">Primary</button>`}
					</pre>
				</div>
			</div>

			<div className="space-y-4">
				<h3 className="font-semibold text-slate-100">What you'll find</h3>
				<ul className="list-disc list-inside text-slate-400">
					<li>Ready-made component templates (cards, modals, navs, footers).</li>
					<li>Accessibility best practices and keyboard interactions.</li>
					<li>Utility-first styling examples for quick customization.</li>
				</ul>
			</div>

			<div className="flex flex-col md:flex-row gap-3 md:gap-4 items-center">
				<Link href="/Accordions">
					<a className="px-4 py-2 rounded bg-amber-500 text-white font-semibold hover:shadow-lg">Explore Components</a>
				</Link>
				<a
					href="https://github.com/metatech-programmer"
					target="_blank"
					rel="noopener noreferrer"
					className="px-4 py-2 rounded border border-slate-700 text-slate-200 hover:bg-slate-800/50"
				>
					View on GitHub
				</a>
			</div>

			<footer className="text-sm text-slate-500 pt-4 border-t border-slate-700">
				<p className="mb-1">Questions or feedback? Open an issue on GitHub or contact the author.</p>
				<p>Designed for fast prototyping and production usage.</p>
			</footer>
		</section>
	);
};

export default PageResourceComponents;


